import { SplitContainer } from '@if/mui'
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material'
import type { ReactNode } from 'react'

// A responsive grid of field placeholders (2 columns on xs, `columns` on md+),
// matching a fieldset's field grid.
const FieldGrid = ({ count, columns = 3 }: { count: number; columns?: number }) => (
  <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: `repeat(${columns}, 1fr)` } }}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={48} />
    ))}
  </Box>
)

const TitledCard = ({ children }: { children: ReactNode }) => (
  <Card>
    <CardContent>
      <Stack spacing={2}>
        <Skeleton width={160} height={24} />
        {children}
      </Stack>
    </CardContent>
  </Card>
)

const WorksheetSkeleton = () => (
  <SplitContainer
    main={
      <Stack spacing={3}>
        {/* Loan details — a 6-field grid plus a couple of option rows. */}
        <TitledCard>
          <FieldGrid count={6} />
          <Skeleton variant="rounded" height={40} width="60%" />
          <Skeleton variant="rounded" height={40} width="45%" />
        </TitledCard>
        {/* Payment breakdown. */}
        <TitledCard>
          <Skeleton height={40} />
          <Skeleton height={40} />
        </TitledCard>
      </Stack>
    }
    aside={
      // Funding summary — a big value on top, then two 2-column field grids and a footnote.
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Skeleton width={140} height={24} />
            <Skeleton variant="rounded" height={56} />
            <FieldGrid count={6} columns={2} />
            <Skeleton width={120} height={20} />
            <FieldGrid count={4} columns={2} />
            <Skeleton variant="text" width="80%" />
          </Stack>
        </CardContent>
      </Card>
    }
  />
)

export default WorksheetSkeleton
